import { Layout } from '@lemonade-hq/uniclient-theme';
import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

interface ItemContainerProps extends PropsWithChildren<{ readonly style?: React.CSSProperties }> {}

export const ItemContainer = forwardRef<HTMLDivElement, ItemContainerProps>(({ children, style }, _) => (
  <Layout position="relative" role="listitem" style={style} width="100%">
    {children}
  </Layout>
));
